'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';


interface StickyHeaderNavProps {
  isScrolled?: boolean;
}

const StickyHeaderNav = ({ isScrolled = false }: StickyHeaderNavProps) => {
  const [scrolled, setScrolled] = useState(isScrolled);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');

  const navigationItems = [
  { id: 'hero', label: 'Home', href: '#Hero' },
  { id: "India\'s Plastic Crisis Demands Immediate Action", label: 'The Challenge', href: "#India\'s Plastic Crisis Demands Immediate Action" },
  { id: 'Key Impact Numbers', label: 'Our Solution', href: '#Key Impact Numbers' },
  { id: 'Vision & Mission', label: 'Vision 2047', href: '#Vision & Mission' },
  { id: 'Certification Standards & Testing', label: 'Certification', href: '#Certification Standards & Testing' },
  { id: 'Measurable Environmental Impact', label: 'Impact', href: '#Measurable Environmental Impact' },
  { id: 'Applications Across Industries', label: 'Applications', href: '#Applications Across Industries' },
  { id: 'membership', label: 'Membership', href: '#Membership' }];


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    const observerOptions = {
      root: null,
      rootMargin: '-100px 0px -80% 0px',
      threshold: 0
    };

    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    navigationItems.forEach((item) => {
      const element = document.getElementById(item.id);
      if (element) observer.observe(element);
    });

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const targetId = href.replace('#', '');
    const element = document.getElementById(targetId);

    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }

    setMobileMenuOpen(false);
  };

  const handleMembershipClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const element = document.getElementById('membership');

    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <header data-component-id="src/components/common/StickyHeaderNav.tsx:99:6" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="99" data-component-end-line="147" data-component-file="StickyHeaderNav.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
        className={`fixed top-0 left-0 right-0 z-[1000] transition-all duration-250 ${
        scrolled ? 'bg-card shadow-md' : 'bg-card'}`
        }>

        <nav data-component-id="src/components/common/StickyHeaderNav.tsx:104:8" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="104" data-component-end-line="146" data-component-file="StickyHeaderNav.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-6 lg:px-8">
          <div data-component-id="src/components/common/StickyHeaderNav.tsx:105:10" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="105" data-component-end-line="145" data-component-file="StickyHeaderNav.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20h-20%22%7D" className="flex items-center justify-between h-20">
            <Link data-component-id="src/components/common/StickyHeaderNav.tsx:106:12" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="106" data-component-end-line="112" data-component-file="StickyHeaderNav.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%20space-x-%22%7D" href="/" className="flex items-center space-x-">
  <img data-component-id="src/components/common/StickyHeaderNav.tsx:107:2" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="107" data-component-end-line="111" data-component-file="StickyHeaderNav.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Fassets%2Flogo%2Ficpa-logo.png%22%2C%22alt%22%3A%22ICPA%20Logo%22%2C%22className%22%3A%22h-16%20w-auto%22%7D"
    src="/assets/logo/icpa-logo.png"
    alt="ICPA Logo"
    className="h-16 w-auto"
  />
</Link>

            <div data-component-id="src/components/common/StickyHeaderNav.tsx:114:12" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="114" data-component-end-line="128" data-component-file="StickyHeaderNav.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20space-x-8%22%7D" className="hidden lg:flex items-center space-x-8">
              {navigationItems.map((item) =>
              <a data-component-id="src/components/common/StickyHeaderNav.tsx:116:14" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="116" data-component-end-line="126" data-component-file="StickyHeaderNav.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                key={item.id}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`font-inter font-medium text-base transition-colors duration-250 ${
                activeSection === item.id ?
                'text-[#22c55e]' : 'text-text-secondary hover:text-[#22c55e]'}`
                }>

                  {item.label}
                </a>
              )}
            </div>

            <div data-component-id="src/components/common/StickyHeaderNav.tsx:130:12" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="130" data-component-end-line="132" data-component-file="StickyHeaderNav.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Ablock%22%7D" className="hidden lg:block">
              
            </div>

            <button data-component-id="src/components/common/StickyHeaderNav.tsx:134:12" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="134" data-component-end-line="144" data-component-file="StickyHeaderNav.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20p-2%20text-text-secondary%20hover%3Atext-primary%20transition-colors%22%7D"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 text-text-secondary hover:text-primary transition-colors"
              aria-label="Toggle menu">

              <Icon data-component-id="src/components/common/StickyHeaderNav.tsx:139:14" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="139" data-component-end-line="142" data-component-file="StickyHeaderNav.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
                name={mobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
                size={28}
                variant="outline" />

            </button>
          </div>
        </nav>
      </header>

      {mobileMenuOpen &&
      <div data-component-id="src/components/common/StickyHeaderNav.tsx:150:6" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="150" data-component-end-line="178" data-component-file="StickyHeaderNav.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-%5B1100%5D%20lg%3Ahidden%22%7D" className="fixed inset-0 z-[1100] lg:hidden">
          <div data-component-id="src/components/common/StickyHeaderNav.tsx:151:10" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="151" data-component-end-line="153" data-component-file="StickyHeaderNav.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-background%22%7D"
          className="absolute inset-0 bg-background"
          onClick={() => setMobileMenuOpen(false)} />

          <div data-component-id="src/components/common/StickyHeaderNav.tsx:155:10" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="155" data-component-end-line="177" data-component-file="StickyHeaderNav.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-20%20left-0%20right-0%20bg-card%20shadow-lg%22%7D" className="absolute top-20 left-0 right-0 bg-card shadow-lg">
            <nav data-component-id="src/components/common/StickyHeaderNav.tsx:156:12" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="156" data-component-end-line="176" data-component-file="StickyHeaderNav.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22px-6%20py-4%20space-y-4%22%7D" className="px-6 py-4 space-y-4">
              {navigationItems.map((item) =>
            <a data-component-id="src/components/common/StickyHeaderNav.tsx:158:12" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="158" data-component-end-line="168" data-component-file="StickyHeaderNav.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
              key={item.id}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className={`block py-3 font-inter font-medium text-base transition-colors ${
              activeSection === item.id ?
              'text-[#22c55e]' : 'text-text-secondary'}`
              }>

                  {item.label}
                </a>
            )}
              <button data-component-id="src/components/common/StickyHeaderNav.tsx:170:14" data-component-path="src/components/common/StickyHeaderNav.tsx" data-component-line="170" data-component-end-line="175" data-component-file="StickyHeaderNav.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20mt-4%20px-6%20py-3%20bg-gradient-to-r%20from-primary%20to-secondary%20text-white%20font-onest%20font-semibold%20rounded-lg%20shadow-membership-cta%22%2C%22textContent%22%3A%22Apply%20for%20Membership%22%7D"
              onClick={handleMembershipClick}
              className="w-full mt-4 px-6 py-3 bg-gradient-to-r from-primary to-secondary text-white font-onest font-semibold rounded-lg shadow-membership-cta">

                Apply for Membership
              </button>
            </nav>
          </div>
        </div>
      }
    </>);


};


export default StickyHeaderNav;
